export function getNameFromFileId(id: string) {
  const idSplitUp = id.split("/");
  const endsInSlash = id[id.length - 1] === "/";
  return idSplitUp.length > 1 ? idSplitUp[idSplitUp.length - (endsInSlash ? 2 : 1)] : id;
}
